import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons/faPrint";
import React, { useRef } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { useReactToPrint } from "react-to-print";
import { trackerFlightListPrint } from "../../analytics/AnalyticsActions";
import { selectConfig } from "../../config/ConfigSlice";
import SearchFlightsResult from "./SearchFlightsResult";
import {
  FlightResultContent,
  selectChosenFlightsResults,
} from "../searchFlightsSlice";
import { currentYear } from "../../../utils";
import { useTranslation } from "react-i18next";
import SearchFlightsFormContent from "../form/SearchFlightsFormContent";
import SearchFlightsResultANA from "./SearchFlightsResultANA";

function SearchFlightsResultsPrint() {
  const chosenResults: FlightResultContent = useAppSelector(
    selectChosenFlightsResults
  );
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { app, mapper } = useAppSelector(selectConfig);
  const printRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: app.title,
    onBeforePrint: async () => {
      dispatch(trackerFlightListPrint());
    },
  });

  const customerId = app.customerId;
  const anaClientIds = ["ANA-dom", "ANA-dom-ja", "ANA-intl", "ANA-intl-ja"];
  const isANAClient = anaClientIds.some((id) => customerId.includes(id));

  if (!chosenResults) {
    return null;
  } else {
    return (
      <>
        <button
          id="print-page-button"
          className="button is-primary"
          onClick={handlePrint}
          disabled={
            !chosenResults.filtered || chosenResults.filtered.length === 0
          }
        >
          <span className="icon is-small">
            <FontAwesomeIcon icon={faPrint} />
          </span>
          <span>{t("BUTTON_PRINT_PAGE")}</span>
        </button>
        <div id="print search-flights-results" style={{ display: "none" }}>
          <div className="card m-1" ref={printRef}>
            <div className="card-header">
              <p className="card-header-title">{app.title}</p>
            </div>
            <div className="card-content">
              <div className="content">
                <SearchFlightsFormContent />
                <table>
                  <tbody>
                    {chosenResults.filtered.map((result, i) =>
                      isANAClient ? (
                        <SearchFlightsResultANA
                          key={i}
                          result={result}
                          dateMin={chosenResults.dateMin}
                          dateMax={chosenResults.dateMax}
                          mapper={mapper}
                        />
                      ) : (
                        <SearchFlightsResult
                          key={i}
                          result={result}
                          dateMin={chosenResults.dateMin}
                          dateMax={chosenResults.dateMax}
                          mapper={mapper}
                        />
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer">
              <span>{`© ${currentYear} ${t("OAG_DISCLAIMER")}`}</span>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SearchFlightsResultsPrint;
